<template>
  <div id="app"><div id="GenesPie" class="GenesPie"></div></div>
</template>
        
<script>
import * as echarts from "echarts";
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "GenesPie",
  data() {
    return {
      pie: [],
      data: [],
    };
  },
  methods: {
    async initChart() {
      this.pie = [];
      this.data = [];
      this.char = echarts.init(document.getElementById("GenesPie"));
      this.char.setOption({
        title: {
          text: "Gene statistics",
          left: "center",
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)",
        },
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: "rgba(0, 0, 0, 0.5)",
          },
        },
      });
      await this.$axios.get("/api/api.echarts/pieChart/genes").then((res) => {
        this.pie = res.data.data;
        console.log(res.data);
        this.char.setOption({
          series: [
            {
              type: "pie",
              radius: ['40%', '70%'],
              center: ["50%", "50%"],
              selectedMode: "single",
              name: "gene",
              data: this.pie,
              label: {
                position: "outer",
                alignTo: "edge",
                margin: 0,
              },
            },
          ],
        });
      });

      this.pie.forEach((element) => {
        if (element.name != null) {
          this.data.push(element);
        }
      });
    },
  },

  async mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
  },
};
</script>
        <style>
.GenesPie {
  width: 570px;
  height: 250px;
  margin: auto;
  background-color: white;
  border-radius: 10px;
}
</style>